export const SET_PRODUCTS = 'SET_PRODUCTS';

export const TESTE = 'TESTE'

export const PRICE_VALUE = 'PRICE_VALUE'

